import { AssetSettings } from '@unistocks/features/portfolios/components/asset-settings/asset-settings';
import { AssetSettingsContext } from '@unistocks/features/portfolios/components/asset-settings/asset-settings-context';
import { PortfolioBase } from '@unistocks/features/portfolios/models/portfolio-base';
import { SectionAssetDto } from '@unistocks/proxy/axios-client';
import { useState } from 'react';

export type AssetSettingsProviderProps = {
  portfolio?: PortfolioBase;
  children: React.ReactNode;
};

export const AssetSettingsProvider: React.FC<AssetSettingsProviderProps> = ({
  portfolio,
  children
}) => {
  const [assetSettingsData, setAssetSettingsData] = useState<SectionAssetDto | null>(null);
  const [assetSettingsOpen, setAssetSettingsOpen] = useState(false);

  const openSettings = (asset: SectionAssetDto) => {
    setAssetSettingsData(asset);
    setAssetSettingsOpen(true);
  };

  return (
    <AssetSettingsContext.Provider value={{ openSettings }}>
      {children}
      {assetSettingsData && portfolio ? (
        <AssetSettings
          key={`${portfolio.id}:${assetSettingsData.sectionId}:${assetSettingsData.id}`}
          portfolio={portfolio}
          asset={assetSettingsData}
          open={assetSettingsOpen}
          onOpenChange={setAssetSettingsOpen}
        />
      ) : null}
    </AssetSettingsContext.Provider>
  );
};

AssetSettingsProvider.displayName = 'AssetSettingsProvider';
